import {
  GET_MARKET,
  GET_MARKET_SUCCESS,
  GET_MARKET_FAIL,
  DELETE_MARKET,
  DELETE_MARKET_SUCCESS,
  DELETE_MARKET_FAIL,
  UPDATE_MARKET,
  UPDATE_MARKET_SUCCESS,
  UPDATE_MARKET_FAIL,
  ADD_NEW_MARKET,
  ADD_MARKET_SUCCESS,
  ADD_MARKET_FAIL,
  MARKET_LOADING,
  MARKET_RESET,
} from "./actionType";

export const resetMarketState = (actionType) => ({
  type: MARKET_RESET,
  payload: { actionType },
});

export const getMarketSuccess = (actionType, data) => ({
  type: GET_MARKET_SUCCESS,
  payload: { actionType, data },
});

export const getMarketFail = (actionType, error) => ({
  type: GET_MARKET_FAIL,
  payload: { actionType, error },
});

export const getMarket = (data) => ({
  type: GET_MARKET,
  payload: data,
});

export const getMarketLoading = () => ({
  type: MARKET_LOADING,
});

export const deleteMarket = (data) => ({
  type: DELETE_MARKET,
  payload: data,
});

export const deleteMarketSuccess = (data) => ({
  type: DELETE_MARKET_SUCCESS,
  payload: data,
});

export const deleteMarketFail = (error) => ({
  type: DELETE_MARKET_FAIL,
  payload: error,
});

export const updateMarket = (data) => ({
  type: UPDATE_MARKET,
  payload: data,
});

export const updateMarketFail = (error) => ({
  type: UPDATE_MARKET_FAIL,
  payload: error,
});

export const updateMarketSuccess = (data) => ({
  type: UPDATE_MARKET_SUCCESS,
  payload: data,
});

export const addNewMarket = (data) => ({
  type: ADD_NEW_MARKET,
  payload: data,
});

export const addMarketSuccess = (data) => ({
  type: ADD_MARKET_SUCCESS,
  payload: data,
});

export const addMarketFail = (error) => ({
  type: ADD_MARKET_FAIL,
  payload: error,
});
